var _path, _rect, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path4, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _path5, _rect13, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Sales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e3a600",
    d: "M30,38H18v3c0,0.552,0.448,1,1,1h10c0.552,0,1-0.448,1-1V38z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4,
    x: 32,
    y: 34,
    fill: "#e3a600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#edbe00",
    d: "M16,38H4v3c0,0.552,0.448,1,1,1h10c0.552,0,1-0.448,1-1V38z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#edbe00",
    d: "M44,38H32v3c0,0.552,0.448,1,1,1h10c0.552,0,1-0.448,1-1V38z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4,
    x: 32,
    y: 30,
    fill: "#edbe00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4,
    x: 32,
    y: 26,
    fill: "#e3a600"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4,
    x: 32,
    y: 22,
    fill: "#edbe00"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4,
    x: 4,
    y: 34,
    fill: "#e3a600"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4,
    x: 4,
    y: 30,
    fill: "#edbe00"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4,
    x: 4,
    y: 26,
    fill: "#e3a600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#edbe00",
    d: "M15,22H5c-0.552,0-1,0.448-1,1v3h12v-3C16,22.448,15.552,22,15,22z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4,
    x: 32,
    y: 18,
    fill: "#e3a600"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4,
    x: 32,
    y: 14,
    fill: "#edbe00"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4,
    x: 18,
    y: 30,
    fill: "#e3a600"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4,
    x: 18,
    y: 34,
    fill: "#edbe00"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4,
    x: 18,
    y: 26,
    fill: "#edbe00"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4,
    x: 18,
    y: 22,
    fill: "#e3a600"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4,
    x: 18,
    y: 18,
    fill: "#edbe00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e3a600",
    d: "M29,14H19c-0.552,0-1,0.448-1,1v3h12v-3C30,14.448,29.552,14,29,14z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4,
    x: 32,
    y: 10,
    fill: "#e3a600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#edbe00",
    d: "M43,6H33c-0.552,0-1,0.448-1,1v3h12V7C44,6.448,43.552,6,43,6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Sales);
export default __webpack_public_path__ + "static/media/icons8-sales.e200f3eb24d7252839ee62666979e703.svg";
export { ForwardRef as ReactComponent };